import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 18498 20362"
    {...props}
  >
    <path
      d="M7761 19236c-1031 0-1851-76-2434-169 583-93 1403-169 2434-169s1853 76 2434 169c-581 93-1403 169-2434 169zm6088-14322-5962 5966-5965-5966h11927zm738-3788c1539 0 2785 1249 2785 2786 0 1536-1246 2786-2785 2786-277-1-549-44-806-121l1827-1828c162-160 209-402 121-613-84-209-289-347-519-347h-3402c68-1479 1288-2663 2779-2663zM7194 11778v6001c-2574 53-3879 486-3879 1288 0 859 1495 1295 4446 1295 2947 0 4444-436 4444-1295 0-803-1308-1236-3884-1289v-5739l4596-4598c509 243 1074 382 1670 382 2157 0 3911-1755 3911-3911 0-2157-1754-3912-3911-3912-2115 0-3837 1689-3905 3789H563c-228 0-433 138-520 347-87 211-39 453 122 613l7029 7029z"
      style={{
        fill: "#322d2c",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
